module.exports = __webpack_public_path__ + "img/022.ac1dec41.jpeg";